import { Component, OnInit } from '@angular/core';
import { LogUpdateService } from '../services/log-update.service';
import { PromptUpdateService } from '../services/prompt-update.service';

@Component({
  selector: 'app-website',
  templateUrl: './website.component.html',
  styleUrls: ['./website.component.scss']
})
export class WebsiteComponent implements OnInit {

  constructor(    
    // private appUpdate: PromptUpdateService
   ){ }

  ngOnInit(): void {
  }

}
